import Tasks from 'APP/Tasks';
import Entities from 'STORE';
import { ArticlePayload } from 'STORE/Messages/Message/Payload/ArticlePayload/ArticlePayload';

export async function createArticle(groupId: string, payload: ArticlePayload): Promise<void> {
  const canSend = Tasks.messaging.canSendMessage({ groupId, payload });
  if (!canSend.result) {
    canSend.error && Tasks.app.showToast(canSend.error);
    return;
  }

  await Tasks.messaging.createNewMessages(groupId, [
    {
      payload,
      repliedMessage: Entities.InputPanelsStore.activeInputPanel.replyMessage,
      quote: Entities.InputPanelsStore.activeInputPanel.quote,
    },
  ]);
}
